import styled from 'styled-components';

import { BaseStyle, ReactTableStyles, Select } from '@nhl/nhl-breakaway-ui';

import { SIZING } from '~/views/components/pageWrapper/styles';

export const MiniTrackerWrapper = styled.div`
    max-width: ${SIZING.maxWidth}px;
    width: 100%;
    padding: 0 ${SIZING.smallHorizontal}px ${SIZING.verticalPadding}px ${SIZING.smallHorizontal}px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding: 0 0 ${SIZING.verticalPadding}px;
    }
`;

export const Heading = styled.div`
    display: flex;
    padding: 24px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
`;
export const DraftHeader = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    padding: 24px 0;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-top: 33px;
    }
`;

export const LiveIndicator = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    color: ${({ theme }) => theme.Utility.critical};
    text-transform: uppercase;
    border: 1px solid ${({ theme }) => theme.Utility.critical};
    border-radius: 4px;
    height: 24px;
    width: 64px;
    justify-content: center;
    align-items: center;

    svg {
        width: 9px;
        fill: ${({ theme }) => theme.Utility.critical};
    }
`;

export const SelectContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 68px;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-width: 156px;
    }
`;

export const SelectCategory = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12mCaps']}
    color: ${({ theme }) => theme.Text.secondary};
    min-width: fit-content;
`;

export const DraftTableContainer = styled.div`
    margin-bottom: 30px;

    ${ReactTableStyles.CommonTableStyling}

    .rt-table-container {
        ${ReactTableStyles.TableScrollShadows};
    }

    .rt-table {
        .rt-tbody .rt-tr:hover {
            border: 1px solid ${({ theme }) => theme.Table.outline};
        }
    }
`;

export const FilterSelect = styled(Select)`
    display: flex;
    min-width: 100%;
`;
